document.addEventListener("DOMContentLoaded", function () {
  const marquee = document.querySelector(".marquee");
  marquee.innerHTML += marquee.innerHTML;

  const marqueeWidth = marquee.offsetWidth;

  function animateMarquee() {
    let startPosition = 0;
    const speed = 0.5;

    function step() {
      startPosition -= speed;
      // Reset start position to ensure a smooth continuous loop
      if (Math.abs(startPosition) >= marqueeWidth / 2) {
        startPosition = 0;
      }
      marquee.style.transform = `translateX(${startPosition}px)`;
      requestAnimationFrame(step);
    }

    requestAnimationFrame(step);
  }

  animateMarquee();
});

$(document).ready(function () {
  var $testimonialSlider = $(".testimonial-slider").slick({
    centerMode: false,
    autoplay: true,
    dots: false,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    loop: false,
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          autoplay: true,
        },
      },
    ],
  });

  function formatNumber(number) {
    return number < 10 ? `0${number}` : number;
  }

  function updateCounter(currentSlide, totalSlides) {
    $(".slider-counter").text(
      `${formatNumber(currentSlide + 1)} / ${formatNumber(totalSlides)}`
    );
  }

  var totalSlides = $testimonialSlider.slick("getSlick").slideCount;
  updateCounter(0, totalSlides);

  $testimonialSlider.on("afterChange", function (event, slick, currentSlide) {
    updateCounter(currentSlide, totalSlides);
  });

  $(".swiper-wrapper").slick({
    centerMode: true,
    autoplay: false,
    dots: false,
    arrows: false,
    centerPadding: "60px",
    slidesToShow: 3,
    responsive: [
      {
        breakpoint: 1680,
        settings: {
          autoplay: false,
          autoplaySpeed: 3000,
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1440,
        settings: {
          autoplay: false,
          autoplaySpeed: 3000,
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });



  $('.product-slider-main').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    fade: false,
    asNavFor: '.product-slider-thumb',
    loop: false,
    responsive: [
        {
            breakpoint: 992,
            settings: {
            }
        },
        {
          breakpoint: 768,
          settings: {
            arrows: false,
          }
        },
        {
          breakpoint: 580,
          settings: {
            arrows: false,
          }
        },
        {
          breakpoint: 380,
          settings: {
            arrows: false,
          }
        }
        ]

});
$('.product-slider-thumb').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    vertical:false,
    asNavFor: '.product-slider-main',
    dots: false,
    focusOnSelect: true,
    verticalSwiping:false,
    arrows: false,
    loop: false,
    responsive: [
    {
        breakpoint: 992,
        settings: {
          vertical: false,
        }
    },
    {
      breakpoint: 768,
      settings: {
        vertical: false,
      }
    },
    {
      breakpoint: 580,
      settings: {
        vertical: false,
        slidesToShow: 3,
      }
    }

    ]
});


// subscription js

$(".selling-plan_one_bar").click(function () {

  $(this).addClass("active");
  $(".subscription-options_outer").removeClass("active");
  $('[data-type="one_time"]').prop("checked", true);
  $('[data-type="subscription"]').prop("checked", false);
    $("#Monthly_membership").attr("name","name-disabled");

});
$(".subscription-options_outer").click(function () {
  $(this).addClass("active");
  $(".selling-plan_one_bar").removeClass("active");
  $('[data-type="one_time"]').prop("checked", false);
  $('[data-type="subscription"]').prop("checked", true);
 var value_4 = $(".subscription-widget input:nth-child(1)").attr('name-disabled');
    $("#Monthly_membership").attr("name","selling_plan");
});
var checkInterval = setInterval(function () {
  // Check if the class 'sls-selling-plan-group-first-line' exists
  if ($(".sls-selling-plan-group-first-line input").length) {
    // Get the value of the 'name' attribute
    var value = $(".sls-selling-plan-group-first-line input").attr("name");
    // Remove the 'name' attribute
    $(".sls-selling-plan-group-first-line input").removeAttr("name");
    // Set the 'name-disabled' attribute with the value of the old 'name' attribute
    $(".sls-selling-plan-group-first-line input").attr(
      "name-disabled",
      value
    );
  }

  // Check if the class 'sls-purchase-options-container' exists
  if ($(".sls-purchase-options-container input").length) {
    // Get the value of the 'name' attribute
    var value2 = $(".sls-purchase-options-container input").attr("name");
    // Remove the 'name' attribute
    $(".sls-purchase-options-container input").removeAttr("name");
    // Set the 'name-disabled' attribute with the value of the old 'name' attribute
    $(".sls-purchase-options-container input").attr("name-disabled", value2);
  }



  // Stop the interval when both classes have been processed
  if (
    $(".sls-selling-plan-group-first-line input").length &&
    $(".sls-purchase-options-container input").length

  ) {
    clearInterval(checkInterval);
  }
}, 100); // The interval is set to check every 100 milliseconds

$(".subscription-widget input").click(function () {
  var value3 = $(this).attr("name-disabled");
  $(this).removeAttr("name-disabled");
  $(this).attr("name", value3);
  $(".subscription-widget input").prop("checked", false);
  $(this).prop("checked", true);
});

  $('.subscription-widget .month_tab').click(function(){
    $('.subscription_text_month').show();
    var price_get = $(this).find('.hidden').text();
    $('span.sub-price').text(price_get);
    $('.subscription_text_annual').hide();
    const selling_plan_value = $(this).find('input').val();
    const currentUrl = window.location.href;
   if (currentUrl.indexOf('selling_plan=') > -1) {
      const url = new URL(currentUrl);
      url.searchParams.delete('selling_plan');
      url.searchParams.append('selling_plan', selling_plan_value);
      window.history.replaceState(null, null, url.href);
  }
  })

 $('.subscription-widget .year_tab').click(function(){
    $('.subscription_text_month').hide();
    var price_get2 = $(this).find('.hidden').text();
   $('span.sub-price').text(price_get2);
    $('.subscription_text_annual').show();
    const selling_plan_value = $(this).find('input').val();
    const currentUrl = window.location.href;
   if (currentUrl.indexOf('selling_plan=') > -1) {
      const url = new URL(currentUrl);
      url.searchParams.delete('selling_plan');
      url.searchParams.append('selling_plan', selling_plan_value);
      window.history.replaceState(null, null, url.href);
  }
  })


});

$(document).on("shopify:section:load", function () {

  $(".swiper-wrapper").slick({
    centerMode: true,
    autoplay: false,
    dots: false,
    arrows: false,
    centerPadding: "60px",
    slidesToShow: 3,
    responsive: [
      {
        breakpoint: 1500,
        settings: {
          autoplay: false,
          autoplaySpeed: 3000,
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });


  $('.product-slider-main').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    fade: false,
    asNavFor: '.product-slider-thumb',
    loop: false,
    responsive: [
        {
            breakpoint: 992,
            settings: {
            }
        },
        {
          breakpoint: 768,
          settings: {
            arrows: false,
          }
        },
        {
          breakpoint: 580,
          settings: {
            arrows: false,
          }
        },
        {
          breakpoint: 380,
          settings: {
            arrows: false,
          }
        }
        ]
});
$('.product-slider-thumb').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    vertical:false,
    asNavFor: '.product-slider-main',
    dots: false,
    focusOnSelect: true,
    verticalSwiping:false,
    arrows: false,
    loop: false,
    responsive: [
    {
        breakpoint: 992,
        settings: {
          vertical: false,
        }
    },
    {
      breakpoint: 768,
      settings: {
        vertical: false,
      }
    },
    {
      breakpoint: 580,
      settings: {
        vertical: false,
        slidesToShow: 3,
      }
    },
    {
      breakpoint: 380,
      settings: {
        vertical: false,
        slidesToShow: 2,
      }
    }
    ]
});

});

//   cart button JS

document.addEventListener("DOMContentLoaded", function () {

document.querySelectorAll(".selling-plan-btn").forEach(function (button) {
  button.addEventListener("click", function () {
    const sellingPlanGroup = this.nextElementSibling;

  });
});

function addToCart(sellingPlanValue) {
  const formData = new FormData(document.querySelector(".form"));
  const data = {};
  formData.forEach((value, key) => {
    data[key] = value;
  });
  if (sellingPlanValue) {
    data.selling_plan = sellingPlanValue;
  }
  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((response) => {
      // Add item to cart successfully
      console.log("Item added to cart");
      const parser = new DOMParser();
      const responseDoc = parser.parseFromString(
        response.sections["cart-drawer"],
        "text/html"
      );
      const cartDrawerContent = responseDoc.querySelector(".cart-drawer");

      if (cartDrawerContent) {
        const cartDrawer = document.querySelector(".cart-drawer");
        if (cartDrawer) {
          cartDrawer.innerHTML = cartDrawerContent.innerHTML;
          const parentElement = cartDrawer.parentElement;
          if (parentElement) {
            parentElement.classList.remove("is-empty"); // Replace "is-empty" with the actual class name
          } else {
            console.error("Parent element not found.");
          }
        } else {
          console.error("Cart drawer element not found in the document.");
        }
      } else {
        console.error("Cart drawer content not found in the response.");
      }
      setTimeout(() => {
        document
          .querySelector("#CartDrawer")
          .parentElement.classList.add("active");
          // Add overflow-hidden class to the body when CartDrawer becomes active
        document.body.classList.add("overflow-hidden");
      }, 1000);
    })
    .catch((error) => {
      // Handle errors
      console.error("Error adding item to cart:", error);
    });
}


const sellingPlanRadios = document.querySelectorAll(".selling-plan-radio");
sellingPlanRadios.forEach(radio => {
  radio.addEventListener("change", (event) => {
    addToCart(event.target.value);
 var radioButton = document.getElementById('selling_plan_3892805829');

  // Check if the radio button exists
  if (radioButton) {
    // Set a timeout to uncheck the radio button after 3 seconds (3000 milliseconds)
    setTimeout(function() {
      radioButton.checked = false; // Uncheck the radio button
    }, 3000);
  }
  });
});


const addToCartBtn = document.getElementById("add-to-cart-btn");
addToCartBtn.addEventListener("click", () => {
  const formData = new FormData(document.querySelector(".form"));
  const data = {};
  formData.forEach((value, key) => {
    data[key] = value;
  });

  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((response) => {
      // Add item to cart successfully
      console.log("Item added to cart");
      const parser = new DOMParser();
      const responseDoc = parser.parseFromString(
        response.sections["cart-drawer"],
        "text/html"
      );
      const cartDrawerContent = responseDoc.querySelector(".cart-drawer");

      if (cartDrawerContent) {
        const cartDrawer = document.querySelector(".cart-drawer");
        if (cartDrawer) {
          cartDrawer.innerHTML = cartDrawerContent.innerHTML;

          // Remove a class from the parent element of cartDrawer
          const parentElement = cartDrawer.parentElement;
          if (parentElement) {
            parentElement.classList.remove("is-empty"); // Replace "is-empty" with the actual class name
          } else {
            console.error("Parent element not found.");
          }
        } else {
          console.error("Cart drawer element not found in the document.");
        }
      } else {
        console.error("Cart drawer content not found in the response.");
      }
      setTimeout(() => {
        document
          .querySelector("#CartDrawer")
          .parentElement.classList.add("active");
          document.body.classList.add("overflow-hidden");
      }, 1000);
    })
    .catch((error) => {
      // Handle errors
      console.error("Error adding item to cart:", error);
    });
});


});

//   Banner on scroll class added

document.addEventListener("DOMContentLoaded", function () {
  // Select the hero-banner and cart-wrapper
  const heroBanner = document.querySelector('.hero-banner');
  const cartWrapper = document.querySelector('.cart-wrapper');

  // Function to check if hero-banner is out of view
  function checkCartWrapperPosition() {
    const heroBannerRect = heroBanner.getBoundingClientRect();

    // If the bottom of the hero-banner is less than or equal to 0, it means it's out of view
    if (heroBannerRect.bottom <= 0) {
      cartWrapper.classList.add('cart-fixed');
    } else {
      cartWrapper.classList.remove('cart-fixed');
    }
  }

  // Listen to the scroll event
  window.addEventListener('scroll', checkCartWrapperPosition);
});


// Blog filter JS
const filterToggle = document.getElementById('filter-toggle');
const filterBox = document.querySelector('.filter_box');
const filterLinks = filterBox.querySelectorAll('a');
filterToggle.addEventListener('click', function() {
filterBox.classList.toggle('filter_show');
});
filterLinks.forEach(link => {
link.addEventListener('click', function() {
  filterBox.classList.remove('filter_show');
});
});



